import { render, staticRenderFns } from "./TotalScore.vue?vue&type=template&id=f56a0796&"
import script from "./TotalScore.vue?vue&type=script&lang=js&"
export * from "./TotalScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports